import React from 'react';
import { Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useThemeStore, PaletteKey } from '../../stores/themeStore';

/**
 * Map each palette to its corresponding logo SVG file in /public.
 */
const LOGO_MAP: Record<PaletteKey, string> = {
  'editorial-neutral': '/logo-editorial-neutral.svg',
  'cyber-street': '/logo-cyber-street.svg',
  'modern-minimalist': '/logo-modern-minimalist.svg',
  'dark-luxe': '/logo-dark-luxe.svg',
};

interface HooliahLogoProps {
  /** Height of the logo in pixels (width scales proportionally). Default 36. */
  height?: number;
  /** If true, the logo links to "/". Default true. */
  linkToHome?: boolean;
}

/**
 * Theme-aware Hooliah logo that swaps SVG based on the active palette.
 */
const HooliahLogo: React.FC<HooliahLogoProps> = ({ height = 36, linkToHome = true }) => {
  const palette = useThemeStore((state) => state.palette);
  const src = LOGO_MAP[palette];

  const img = (
    <Box
      component="img"
      src={src}
      alt="Hooliah"
      sx={{
        height,
        width: 'auto',
        display: 'block',
        objectFit: 'contain',
      }}
    />
  );

  if (!linkToHome) return img;

  return (
    <Box
      component={RouterLink}
      to="/"
      sx={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        flexShrink: 0,
      }}
      aria-label="Hooliah home"
    >
      {img}
    </Box>
  );
};

export default HooliahLogo;
